export default __webpack_public_path__ + "static/GT-America-Condensed-Black-591059fc872878b2a1a698ba73a4321d.ttf";